import styled from 'styled-components';

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 70vw;
  max-width: 95vw;

  height: 100vh;
  max-height: 88vh;

  border-radius: 0.5rem;
  background-color: var(--white);
  @media (max-width: 880px) {
    width: 95;
  }
`;

export const ContainerLoading = styled.div`
  svg {
    width: 1rem;
    height: 1rem;
  }
  span {
    width: 1rem !important;
    height: 1rem !important;
  }
`;
export const Input = styled.div`
  padding-right: 1rem;
  width: 100%;
`;

export const Button = styled.div`
  padding-left: 1rem;
  margin-top: 0.5rem;
`;
export const Icons = styled.div`
  display: flex;
  justify-content: space-around;
  padding-top: 1rem;
  svg {
    width: 4rem;
    height: 4rem;
    color: #00c49a;
    border: 1px solid #8383af;
    padding: 0.7rem;
    border-radius: 50px;
    cursor: pointer;
  }
  padding-left: 1rem;
  margin-top: 0.5rem;
`;

export const ModalHeader = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  flex-grow: 0;

  padding: 1.75rem 1.5rem;

  box-shadow: 0 4px 8px 3px rgba(0, 0, 0, 0.06), 0 1px 3px rgba(0, 0, 0, 0.12);

  & > button {
    position: absolute;
    top: 1.5rem;
    right: 1.5rem;

    width: 1rem;
    height: 1rem;

    background: transparent;
    border: none;
    color: #83834f;

    & > svg {
      width: 1rem;
      height: 1rem;
    }
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-grow: 1;
  // flex-direction: column;

  padding: 1.5rem 2.5rem;
  align-items: center;

  .label {
    margin-bottom: 1rem;
  }

  & > small {
    margin-bottom: 1rem;
  }

  h6 {
    margin-bottom: 1rem;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  gap: 1rem;

  box-shadow: 0 -4px 8px 3px rgba(0, 0, 0, 0.06), 0 -1px 3px rgba(0, 0, 0, 0.12);

  padding: 1.5rem 2.5rem;
`;
export const ContainerProductType = styled.div`
  display: flex;
  margin-top: 1.5rem;
`;
export const ContainerRadio = styled.div`
  // border: ${(props) => props.color};
  display: flex;
  margin-right: 16px;
  align-items: center;
  height: 48px;
  border-radius: 1px;
  padding: 16px, 32px, 16px, 32px;
  h6 {
  }
  span {
    padding-left: 1rem;
    color: #333333;
    font-size: 16px;
    font-weight: 400;
  }
`;
